<atlas-modal>
  <atlas-modal-header [hideCloseBtn]="true">
    Restricted: Secure Data Access
    @if (!(this.dialogRef.disableClose ?? true)) {
      <button mat-icon-button (click)="closeDialog()">
        <mat-icon>close</mat-icon>
      </button>
    }
  </atlas-modal-header>
  <atlas-modal-content class="content">
    <div class="glxy-override-context">
      <glxy-alert type="warning">
        <span class="notice-text">
          <strong>NOTICE:</strong> You are entering a secure environment containing Protected Health Information (PHI)
          and SOC II-regulated data. Access is restricted to authorized users for specific business purposes only. All
          activity, including data viewed or exported, is logged and auditable under HIPAA Security Rule
          &sect;164.312(b) and SOC II compliance requirements. Please proceed with caution. You are responsible to keep
          any Personal Identifiable Information (PII), PHI, and financial information confidential. Information that you
          access cannot be shared without proper consent and written approval.
        </span>
      </glxy-alert>
    </div>
    <p class="text">You will receive the following access</p>
    @let entitlementState = entitlementState$ | async;
    @if (!entitlementState || entitlementState.loading) {
      <glxy-loading-spinner></glxy-loading-spinner>
    } @else if (entitlementState.error) {
      <div class="glxy-override-context">
        <glxy-alert type="error">
          <strong>Error fetching entitlement information</strong>
        </glxy-alert>
      </div>
    } @else if (entitlementState.entitlement) {
      <mat-card>
        <mat-card-header>
          <mat-card-title>{{ entitlementState.entitlement.name }}</mat-card-title>
        </mat-card-header>
        <mat-card-content>{{ entitlementState.entitlement.description }}</mat-card-content>
      </mat-card>
    }
    <glxy-form-field class="form">
      <glxy-label>Reason for access</glxy-label>
      <mat-select [formControl]="reasonType">
        @for (reasonOption of COMMON_REASONS; track reasonOption) {
          <mat-option [value]="reasonOption">{{ reasonOption }}</mat-option>
        }
      </mat-select>
    </glxy-form-field>
    @if (reasonType.value === 'Other') {
      <glxy-form-field class="form">
        <glxy-label>Custom reason</glxy-label>
        <textarea matInput placeholder="Provide a reason for requiring access" [formControl]="reason"></textarea>
      </glxy-form-field>
    }
  </atlas-modal-content>
  <atlas-modal-footer>
    @if (escapeFn && dialogRef.disableClose) {
      <button mat-stroked-button (click)="goBack()">Go back</button>
    }
    <button mat-flat-button color="primary" (click)="createGrant()">Get access</button>
  </atlas-modal-footer>
</atlas-modal>
